module.exports = __webpack_public_path__ + "img/pitching11.ab043e93.png";